<div class="half-donut-card">
  <div class="half-donut-card__header">
    <span class="text">{{ text }}</span>

    <button *ngIf="showInfoIcon" type="button" class="info-button" (click)="openInfoModal()" aria-label="Información">
      <ion-icon name="information-circle"></ion-icon>
    </button>
  </div>
  <div class="chart-box">
    <canvas baseChart [type]="doughnutChartType" [data]="doughnutChartData" [options]="doughnutChartOptions">
    </canvas>

    <div class="center-label">
      <span class="value">{{ displayValue }}%</span>
    </div>
  </div>
</div>